import * as irctcForgotPasswordActions from './../actions/irctcForgotPasswordActions';
import { IRCTC_FORGOT_PASSWORD_COMPONENTS, IRCTC_PASSWORD_RADIO } from '../utils/RailsSEOConstants';

export const irctcForgotPasswordInitialState = {
  componentToShow: IRCTC_FORGOT_PASSWORD_COMPONENTS.inputForm,
  modeOfPasswordSent: IRCTC_PASSWORD_RADIO.MOBILE.key,
  userName: null,
  mobileNumber: null,
  userEmail: null,
  showErrorInputForm: false,
  submitFailedErrorMessageEmail: '',
  submitFailedErrorMessageMobileNumber: ''
};

export const irctcForgotPasswordReducer = (state, action) => {
  if (typeof action !== 'object') {
    return state;
  }
  switch (action.type) {
    case irctcForgotPasswordActions.ACTION_SET_COMPONENT_TO_SHOW_FORGOT_PSWD: {
      return {
        ...state,
        componentToShow: action.data
      };
    }
    case irctcForgotPasswordActions.ACTION_SET_MODE_OF_PASSWORD_FORGOT_PSWD: {
      return {
        ...state,
        modeOfPasswordSent: action.data
      };
    }
    case irctcForgotPasswordActions.ACTION_SET_USERNAME_FORGOT_PSWD: {
      return {
        ...state,
        userName: action.data
      };
    }
    case irctcForgotPasswordActions.ACTION_SET_MOBILE_NUMBER_FORGOT_PSWD: {
      return {
        ...state,
        mobileNumber: action.data
      };
    }
    case irctcForgotPasswordActions.ACTION_SET_USER_EMAIL_FORGOT_PSWD: {
      return {
        ...state,
        userEmail: action.data
      };
    }
    case irctcForgotPasswordActions.ACTION_SET_SHOW_ERROR_INPUT_FORM_FORGOT_PSWD: {
      return {
        ...state,
        showErrorInputForm: action.data
      };
    }
    case irctcForgotPasswordActions.ACTION_SET_SUBMIT_FAILED_ERR_MSG_EMAIL: {
      return {
        ...state,
        submitFailedErrorMessageEmail: action.data
      };
    }
    case irctcForgotPasswordActions.ACTION_SET_SUBMIT_FAILED_ERR_MSG_MOBILE: {
      return {
        ...state,
        submitFailedErrorMessageMobileNumber: action.data
      };
    }
    default: {
      return state;
    }
  }
};
